<template>
    <!-- 添加或修改用户配置对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="650px" append-to-body>
        <el-form ref="form" :model="form" :rules="rules" label-width="140px" style="height: 500px;overflow: auto;">
            <el-row>
                <el-col :span="24" v-if="title == '买货详情'">
                    <el-form-item label="任务编码">
                        {{ dataNo.tasknumber }}
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="指派人">
                        {{ dataNo.dealername }}
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="购买平台">
                        {{ dataNo.platform }}
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="店铺名称">
                        {{ dataNo.shopname }}
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="购买产品">
                        {{ dataNo.productname }}
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="规格">
                        {{ dataNo.specification }}
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="管控标准">
                        {{ dataNo.controlstandard }}
                    </el-form-item>
                </el-col>


                <el-col :span="24">
                    <el-form-item label="单价" prop="unitprice">
                        <el-input v-model="form.unitprice" type="number" clearable placeholder="单价"
                            style="width: 410px;" size="small" :disabled="title == '买货详情' && logintype == 'HCM'" />
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="数量" prop="paynum">
                        <el-input v-model="form.paynum" type="number" clearable placeholder="数量" style="width: 410px;"
                            size="small" :disabled="title == '买货详情' && logintype == 'HCM'" />
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="支付金额" prop="payprice">
                        <el-input v-model="form.payprice" type="number" clearable placeholder="支付金额"
                            style="width: 410px;" size="small" :disabled="title == '买货详情' && logintype == 'HCM'" />
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="支付截图" required>
                        <el-upload class="upload-demo" action="/hcm/hcmWorkOrder/headImgUploadOrder"
                            :show-file-list="false" :before-upload="handleBeforeUpload"
                            :on-success="handleUploadSuccess" accept="image/png, image/jpg" :multiple="true"
                            :ref="elUpload">
                            <el-button size="small" type="primary" v-if="logintype !== 'HCM'">点击上传</el-button>
                        </el-upload>
                        <div v-for="(image, index) in paypricescreenshot" :key="index"
                            style="float: left;margin: 10px 10px 0px 0px;position: relative;">
                            <img :src="image" class="avatar" style="width: 100px; height: 100px;font-size: 20px;" />
                            <i class="el-icon-error" style="position: absolute;right: 10px;top: 10px;cursor: pointer;"
                                @click="delIcon(index)" v-if="logintype !== 'HCM'"></i>
                        </div>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="购买快递单号" prop="couriernumber">
                        <el-input v-model="form.couriernumber" clearable placeholder="购买快递单号" style="width: 410px;"
                            size="small" :disabled="title == '买货详情' && logintype == 'HCM'" />
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="购买人" prop="payuser">
                        <el-input v-model="form.payuser" clearable placeholder="购买人" style="width: 410px;"
                            size="small" :disabled="title == '买货详情' && logintype == 'HCM'" />
                    </el-form-item>
                </el-col>

                <el-col :span="24" v-if="title == '买货详情'">
                    <el-form-item label="原箱编码">
                        {{ form.encoding }}
                    </el-form-item>
                </el-col>
                <el-col :span="24" v-if="title == '买货详情'">
                    <el-form-item label="创建时间">
                        {{ form.createtime | fullTime }}
                    </el-form-item>
                </el-col>
                <el-col :span="24" v-if="title == '买货详情'">
                    <el-form-item label="创建人">
                        {{ form.createuser }}
                    </el-form-item>
                </el-col>
                <el-col :span="24" v-if="title == '买货详情'">
                    <el-form-item label="更新时间" v-if="form.updatetime">
                        {{ form.updatetime | fullTime }}
                    </el-form-item>
                </el-col>
                <el-col :span="24" v-if="title == '买货详情'">
                    <el-form-item label="更新人" v-if="form.updateuser">
                        {{ form.updateuser }}
                    </el-form-item>
                </el-col>

            </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="submitForm" v-if="logintype != 'HCM'">确 定</el-button>
            <el-button @click="cancel">取 消</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: "hcmIndexChildDealer",
    components: {},
    data() {
        return {
            logintype: '',
            elUpload: true,
            // 表单参数
            form: {
                unitprice: null,
                paynum: null,
                payprice: null,
                couriernumber: null,
                payuser: null,
                tasknumber: null,
                dealerid: null,
            },
            rules: {
                unitprice: [
                    { required: true, message: '请填写单价', trigger: 'blur' },
                ],
                paynum: [
                    { required: true, message: '请填写数量', trigger: 'blur' },
                ],
                payprice: [
                    { required: true, message: '请填写支付金额', trigger: 'blur' },
                ],
                couriernumber: [
                    { required: true, message: '请填写快递单号', trigger: 'blur' },
                ],
                payuser: [
                    { required: true, message: '请填写购买人', trigger: 'blur' },
                ]
            },
            paypricescreenshot: [],
            open: false,
            title: '',
            dataNo: {},
        };
    },
    created() { 
        this.logintype = JSON.parse(localStorage.getItem('userData')).logintype;
    },
    methods: {
        // 新增
        handleAdd(data, title) {
            this.title = title;
            this.form.unitprice = null;
            this.form.paynum = null;
            this.form.payprice = null;
            this.form.couriernumber = null;
            this.form.payuser = null;
            this.paypricescreenshot = [];
            if (this.title == '买货详情') {
                this.form = data.details;
                this.paypricescreenshot = this.form.paypricescreenshot.split(',');
                this.dataNo = data.hcmOrdertaskbmc;
            } else {
                if (data) {
                    this.form.tasknumber = data.tasknumber;
                    this.form.dealerid = data.dealerid;
                    this.dataNo = data;
                }
            }
            this.open = true;
        },
        // 删除截图
        delIcon(index) {
            this.paypricescreenshot.splice(index, 1)
        },
        // 图片上传前判断
        handleBeforeUpload(file) {
            const isLt20M = file.size / 1024 / 1024 < 20;
            if (!isLt20M) {
                this.$message.error('上传文件大小不能超过 20MB!');
            }
            return isLt20M;
        },
        // 图片上传成功
        handleUploadSuccess(res) {
            this.paypricescreenshot.push(res.data.data);
            this.form.paypricescreenshot = ''
            this.form.paypricescreenshot = this.paypricescreenshot.join(',');
            this.elUpload = false;
        },
        // 提交
        submitForm() {
            console.log(this.form)
            this.$refs["form"].validate((valid) => {
                if (this.paypricescreenshot.length == 0) {
                    this.$message.warning('请上传支付截图！');
                    return;
                }
                if (valid) {

                    fetch({
                        url: "hcm/hcmOrdergoodsbmc/saveOrdergoodsbmc",
                        method: "post",
                        data: JSON.stringify(this.form),
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        noFormat: false,
                        responseType: "json"
                    }).then((res) => {
                        if (res.status === '10000') {
                            this.$message({
                                message: '操作成功！',
                                type: 'success'
                            })
                            this.open = false;
                            this.$emit('call-parent-method');
                        } else {
                            this.$message.error(res.message);
                        }
                    }).catch(err => {
                        this.$message.error('服务器出错');
                    });
                }
            });
        },
        // 取消
        cancel() {
            this.open = false;
        },
    }
};
</script>
<style lang="scss"></style>